import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_52533713 from 'nuxt_plugin_plugin_52533713' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_0e194bd8 from 'nuxt_plugin_bootstrapvue_0e194bd8' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_toast_dbed1950 from 'nuxt_plugin_toast_dbed1950' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_402b575e from 'nuxt_plugin_cookieuniversalnuxt_402b575e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_templatesplugin5ac7fef5_c169c5aa from 'nuxt_plugin_templatesplugin5ac7fef5_c169c5aa' // Source: ./templates.plugin.5ac7fef5.js (mode: 'client')
import nuxt_plugin_nuxtmq_09cf2171 from 'nuxt_plugin_nuxtmq_09cf2171' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_pluginrouting_59d81106 from 'nuxt_plugin_pluginrouting_59d81106' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_39a36d12 from 'nuxt_plugin_pluginmain_39a36d12' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_744db2ae from 'nuxt_plugin_axios_744db2ae' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vuexpersist_13f465a2 from 'nuxt_plugin_vuexpersist_13f465a2' // Source: ../../../plugins/vuex-persist (mode: 'client')
import nuxt_plugin_typeform_6a609718 from 'nuxt_plugin_typeform_6a609718' // Source: ../../../plugins/typeform (mode: 'client')
import nuxt_plugin_gtag_6a810249 from 'nuxt_plugin_gtag_6a810249' // Source: ../../../plugins/gtag (mode: 'client')
import nuxt_plugin_fbPixel_b342c218 from 'nuxt_plugin_fbPixel_b342c218' // Source: ../../../plugins/fbPixel (mode: 'client')
import nuxt_plugin_rum_5e466354 from 'nuxt_plugin_rum_5e466354' // Source: ../../../plugins/rum (mode: 'client')
import nuxt_plugin_yotpo_32ca1e32 from 'nuxt_plugin_yotpo_32ca1e32' // Source: ../../../plugins/yotpo (mode: 'client')
import nuxt_plugin_bing_6a7e94b6 from 'nuxt_plugin_bing_6a7e94b6' // Source: ../../../plugins/bing (mode: 'client')
import nuxt_plugin_tiktok_383b4820 from 'nuxt_plugin_tiktok_383b4820' // Source: ../../../plugins/tiktok (mode: 'client')
import nuxt_plugin_intercom_1516e49b from 'nuxt_plugin_intercom_1516e49b' // Source: ../../../plugins/intercom (mode: 'client')
import nuxt_plugin_googleSignin_9ef6d892 from 'nuxt_plugin_googleSignin_9ef6d892' // Source: ../../../plugins/googleSignin.js (mode: 'client')
import nuxt_plugin_impact_4aab983b from 'nuxt_plugin_impact_4aab983b' // Source: ../../../plugins/impact.js (mode: 'client')
import nuxt_plugin_hotjar_6900f5d3 from 'nuxt_plugin_hotjar_6900f5d3' // Source: ../../../plugins/hotjar.js (mode: 'client')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../../../plugins/axios.js (mode: 'client')
import nuxt_plugin_commonMixin_4d602c20 from 'nuxt_plugin_commonMixin_4d602c20' // Source: ../../../plugins/commonMixin (mode: 'all')
import nuxt_plugin_googleoptimize_5ae5d34e from 'nuxt_plugin_googleoptimize_5ae5d34e' // Source: ./google-optimize.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en"},"title":"webpage","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Base webpage"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preload","type":"font\u002Fwoff2","href":"https:\u002F\u002Fstatics.get-base.com\u002Ffonts\u002FSwiss_721_Greek_BT.woff2","as":"font","crossorigin":true},{"rel":"preload","type":"font\u002Fttf","href":"https:\u002F\u002Fstatics.get-base.com\u002Ffonts\u002FSwiss-721-Greek-BT_43242.ttf","as":"font","crossorigin":true},{"rel":"preload","type":"font\u002Fwoff","href":"https:\u002F\u002Fstatics.get-base.com\u002Ffonts\u002FSwiss_721_Greek_BT.woff","as":"font","crossorigin":true},{"rel":"preload","as":"image","type":"image\u002Fsvg+xml","href":"https:\u002F\u002Fstatics.get-base.com\u002Ficons\u002Ficon_arrow_right_black.svg"},{"rel":"preload","as":"image","type":"image\u002Fsvg+xml","href":"https:\u002F\u002Fstatics.get-base.com\u002Fbase_logo.svg"},{"rel":"preconnect","href":"https:\u002F\u002Fstatics.get-base.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fjs.stripe.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fgoogletagmanager.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fanalytics.tiktok.com","crossorigin":true}],"script":[{"src":"https:\u002F\u002Fwww.googleoptimize.com\u002Foptimize.js?id=OPT-NQ489C4","async":true}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_52533713 === 'function') {
    await nuxt_plugin_plugin_52533713(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_0e194bd8 === 'function') {
    await nuxt_plugin_bootstrapvue_0e194bd8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_dbed1950 === 'function') {
    await nuxt_plugin_toast_dbed1950(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_402b575e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_402b575e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin5ac7fef5_c169c5aa === 'function') {
    await nuxt_plugin_templatesplugin5ac7fef5_c169c5aa(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_09cf2171 === 'function') {
    await nuxt_plugin_nuxtmq_09cf2171(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_59d81106 === 'function') {
    await nuxt_plugin_pluginrouting_59d81106(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_39a36d12 === 'function') {
    await nuxt_plugin_pluginmain_39a36d12(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_744db2ae === 'function') {
    await nuxt_plugin_axios_744db2ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_13f465a2 === 'function') {
    await nuxt_plugin_vuexpersist_13f465a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_typeform_6a609718 === 'function') {
    await nuxt_plugin_typeform_6a609718(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_6a810249 === 'function') {
    await nuxt_plugin_gtag_6a810249(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fbPixel_b342c218 === 'function') {
    await nuxt_plugin_fbPixel_b342c218(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_rum_5e466354 === 'function') {
    await nuxt_plugin_rum_5e466354(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yotpo_32ca1e32 === 'function') {
    await nuxt_plugin_yotpo_32ca1e32(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bing_6a7e94b6 === 'function') {
    await nuxt_plugin_bing_6a7e94b6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tiktok_383b4820 === 'function') {
    await nuxt_plugin_tiktok_383b4820(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_intercom_1516e49b === 'function') {
    await nuxt_plugin_intercom_1516e49b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleSignin_9ef6d892 === 'function') {
    await nuxt_plugin_googleSignin_9ef6d892(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_impact_4aab983b === 'function') {
    await nuxt_plugin_impact_4aab983b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hotjar_6900f5d3 === 'function') {
    await nuxt_plugin_hotjar_6900f5d3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_commonMixin_4d602c20 === 'function') {
    await nuxt_plugin_commonMixin_4d602c20(app.context, inject)
  }

  if (typeof nuxt_plugin_googleoptimize_5ae5d34e === 'function') {
    await nuxt_plugin_googleoptimize_5ae5d34e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    const { route } = router.resolve(app.context.route.fullPath)
    // Ignore 404s rather than blindly replacing URL
    if (!route.matched.length && process.client) {
      return resolve()
    }
    router.replace(route, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
